import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { BnSemaphoreTooltipComponent } from './bn-semaphore-tooltip.component';

@NgModule({
  imports: [CommonModule, NgbTooltipModule],
  declarations: [BnSemaphoreTooltipComponent],
  exports: [BnSemaphoreTooltipComponent],
})
export class BnSemaphoreTooltipModule {}
